import { getJWT } from '../Utils/Profile'
import { BASEAPI } from './constants'
// Definimos la interfaz ILocalData que representa los datos de una tienda
export interface ILocalData {
    address: string
    commerceInternalID: string
    isActiveMap: boolean
    plan: { planName: string }
    regionName: string
    shopStatus: string
    description: string
    shopId: string
    region: string
    localId: string
}

// Definimos la interfaz IShopsResponse que contiene la propiedad 'shops' que es un array de ILocalData
export interface IShopsResponse {
    shops: ILocalData[]
}

// Función para obtener los datos de las tiendas
const getStores = async (shopName = ''): Promise<ILocalData[]> => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser ? JSON.parse(currentUser) : null
    const token = user?.token || ''

    if (!token) {
        console.error('No se encontró un token válido')
        alert('Hubo un error: Token no disponible')
        return []
    }

    try {
        const response = await fetch(
            `${BASEAPI}commerce/establishments/shops?shopName=${shopName}&limit=10000&`,
            {
                method: 'GET',
                headers: {
                    Authorization: getJWT(),
                },
            }
        )

        if (!response.ok) {
            throw new Error(`Error en la petición: ${response.statusText}`)
        }

        const data: IShopsResponse = await response.json() // Esperamos que la respuesta sea de tipo IShopsResponse

        return data.shops || [] // Retornamos el array de shops
    } catch (error: any) {
        console.log('ERRR', error.message)
        console.error('Error al obtener los comercios:', error)
        alert('Hubo un error al obtener los comercios.')
        return []
    }
}

export { getStores }
